import React from 'react';
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles"
import CorporateActionStatusLookup from "../../../Common/Models/CorporateActionStatusLookup";
import { Catalogue } from "@singularsystems/neo-react-services";
import { CatalogueEntry } from "../CatologueEntry";
import DataCache from "../../StaticData/StaticDataCache";
import { IGeneralApiClient } from '../../../Common/ApiClients/GeneralApiClient';
import { Model } from '@singularsystems/neo-core';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';

export default class CorporateActionStatusCatalogueEntry extends CatalogueEntry<CorporateActionStatusLookup> {

    constructor() {
        super("Corporate Action Statuses", CorporateActionStatusLookup);
    }

    public get editRole() {
        return Roles.CatalogueRoles.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.corporateActionStatuses;
    }

    public getSaveEndpoint(apiClient: IGeneralApiClient) {
        return apiClient.saveCorporateActionStatuses;
    }

    public renderRow(item: CorporateActionStatusLookup, meta: Model.TransformMetaType<CorporateActionStatusLookup>) {
        return (
            <NeoGrid.RowGroup>
                <NeoGrid.Row>
                    <NeoGrid.Column display={meta.stageName} />
                    <NeoGrid.Column display={meta.statusName} />
                    <Catalogue.ButtonColumn />
                </NeoGrid.Row>
            </NeoGrid.RowGroup>
        )
    }

    public renderFormControls(item: CorporateActionStatusLookup, meta: Model.TransformMetaType<CorporateActionStatusLookup>) {
        this.dataCache.corporateActionStages.get();
        return <div>
            <Neo.FormGroup
                label={TextConstants.Labels.CorporateActionStage}
                bind={meta.corporateActionStageId}
                select={{ items: this.dataCache.corporateActionStages.currentData, displayMember: "stageName", valueMember: "corporateActionStageId" }}>
            </Neo.FormGroup>
            <Neo.FormGroup bind={meta.statusName} />
        </div>
    }
}